import DCFGallery from '@dcf/js/components/dcf-gallery.js';

export default class UNLGallery extends DCFGallery {
    constructor(galleryImage, options = {}) {
        super(galleryImage, options);
    }
}
